// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");

function ReportListHeader(props) {
  return JsxRuntime.jsx("thead", {
              children: JsxRuntime.jsxs("tr", {
                    children: [
                      JsxRuntime.jsx("th", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    "Name",
                                    JsxRuntime.jsx("img", {
                                          className: "ml-4-px",
                                          src: Image$ReactHooksTemplate.heading
                                        })
                                  ],
                                  className: "flex"
                                }),
                            className: "px-4 py-3"
                          }),
                      JsxRuntime.jsx("th", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    "Description",
                                    JsxRuntime.jsx("img", {
                                          className: "ml-4-px",
                                          src: Image$ReactHooksTemplate.heading
                                        })
                                  ],
                                  className: "flex"
                                }),
                            className: "px-4 py-3"
                          }),
                      JsxRuntime.jsx("th", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    "Report Template",
                                    JsxRuntime.jsx("img", {
                                          className: "ml-4-px",
                                          src: Image$ReactHooksTemplate.heading
                                        })
                                  ],
                                  className: "flex"
                                }),
                            className: "px-4 py-3"
                          }),
                      JsxRuntime.jsx("th", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    "Time Frame",
                                    JsxRuntime.jsx("img", {
                                          className: "ml-4-px",
                                          src: Image$ReactHooksTemplate.heading
                                        })
                                  ],
                                  className: "flex"
                                }),
                            className: "px-4 py-3"
                          }),
                      JsxRuntime.jsx("th", {
                            children: JsxRuntime.jsx("div", {
                                  children: "Creator",
                                  className: "flex"
                                }),
                            className: "px-4 py-3"
                          }),
                      JsxRuntime.jsx("th", {
                            children: JsxRuntime.jsx("div", {
                                  children: "Modifier",
                                  className: "flex"
                                }),
                            className: "px-4 py-3"
                          }),
                      JsxRuntime.jsx("th", {
                            children: JsxRuntime.jsx("div", {
                                  children: "",
                                  className: "flex"
                                }),
                            className: "px-4 py-3"
                          })
                    ]
                  }),
              className: "font-medium p-4 bg-ghostwhite text-aurometalsaurus"
            });
}

var make = ReportListHeader;

exports.make = make;
/* react/jsx-runtime Not a pure module */
